import { AddRoomReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: AddRoomReducer = {
  addRoom: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
  deleteRoom: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
  editRoom: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
  updateRoom: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
};

const roomReducer = createReducer(initialState, {
  ADD_ROOM_PENDING: (state) => {
    state.addRoom.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  ADD_ROOM_FULFILLED: (state, action) => {
    state.addRoom.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.addRoom.data = action.payload.data;
  },

  ADD_ROOM_REJECTED: (state, action) => {
    state.addRoom.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.addRoom.data = action.payload.data;
  },
  RESET_ADD_ROOM: (state) => {
    state.addRoom.status = {
      loading: false,
      done: false,
      error: false,
    };
    state.addRoom.data = null;
  },
  DELETE_ROOM_PENDING: (state) => {
    state.deleteRoom.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  DELETE_ROOM_FULFILLED: (state, action) => {
    state.deleteRoom.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.deleteRoom.data = action.payload.data;
  },

  DELETE_ROOM_REJECTED: (state, action) => {
    state.deleteRoom.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.deleteRoom.data = action.payload.data;
  },
  EDIT_ROOM_PENDING: (state) => {
    state.editRoom.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  EDIT_ROOM_FULFILLED: (state, action) => {
    state.editRoom.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.editRoom.data = action.payload.data;
  },

  EDIT_ROOM_REJECTED: (state, action) => {
    state.editRoom.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.editRoom.data = action.payload.data;
  },

  RESET_EDIT_ROOM: (state) => {
    state.editRoom.status = {
      loading: false,
      done: false,
      error: false,
    };
    state.editRoom.data = null;
  },
  UPDATE_ROOM_USAGE_PENDING: (state) => {
    state.updateRoom.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  UPDATE_ROOM_USAGE_FULFILLED: (state, action) => {
    state.updateRoom.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.updateRoom.data = action.payload.data;
  },

  UPDATE_ROOM_USAGE_REJECTED: (state, action) => {
    state.updateRoom.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.updateRoom.data = action.payload.data;
  },
  RESET_UPDATE_ROOM_USAGE: (state, action) => {
    state.updateRoom.status = {
      loading: false,
      error: false,
      done: false,
    };
    state.updateRoom.data = null;
  },
});

export default roomReducer;
